import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPrice, createPrice, updatePrice } from './actions';
import PriceSettingsForm, { selector as priceSettingsFormSelector } from './SettingsForm';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';
import { withTranslation } from 'react-i18next';
import { Panel } from 'react-bootstrap';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handlePriceSettingsSubmit = this.handlePriceSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchPrice } = this.props;
		const priceId = match.params.id;

		this.loadGrades();

		if (priceId) {
			fetchPrice(priceId);
		}
	}

	handlePriceSettingsSubmit(values) {
		const { price, createPrice, updatePrice, history } = this.props;

		if (!values.fixedTermPrice) {
			values.termPrice = null;
		}

		if (price) {
			updatePrice(price.id, values);
		} else {
			createPrice(values, history);
		}
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	render() {
		const { price, isReadonly, gradesList, paymentTypes, enableTermPrice, fixedTermPrice, enableTrials, selectedCenter, selectedTerm, t } = this.props;
		const numberOfLessonsInSchoolYear = selectedCenter && selectedCenter.numberOfLessonsInSchoolYear ?
			selectedCenter.numberOfLessonsInSchoolYear :
			(selectedTerm && selectedTerm.schoolYear ? selectedTerm.schoolYear.lessonCount : undefined);
		const lessonCount = numberOfLessonsInSchoolYear ? t('Price_YearLessons', { yearLessonCount: numberOfLessonsInSchoolYear }) : '';
		if (price) {
			return <Panel>
				<Panel.Heading>{t('Common_Details')}</Panel.Heading>
				<Panel.Body>
					<PriceSettingsForm isReadonly={isReadonly} onSubmit={this.handlePriceSettingsSubmit} initialValues={{ ...price, fixedTermPrice: price.termPrice !== null ? true : false }}
						grades={gradesList} lessonCount={lessonCount}
						paymentTypes={paymentTypes} enableTermPrice={enableTermPrice} fixedTermPrice={fixedTermPrice} enableTrials={enableTrials} />
				</Panel.Body>
			</Panel>;
		} else {
			return <Panel>
				<Panel.Heading>{t('Common_Details')}</Panel.Heading>
				<Panel.Body>
					<PriceSettingsForm isReadonly={isReadonly} onSubmit={this.handlePriceSettingsSubmit} initialValues={{ fixedTermPrice: false }}
						grades={gradesList} lessonCount={lessonCount}
						paymentTypes={paymentTypes} enableTermPrice={enableTermPrice} fixedTermPrice={fixedTermPrice} enableTrials={enableTrials} />
				</Panel.Body>
			</Panel>;
		}
	}
}

const mapStateToProps = (state, ownProps) => {
	const priceId = ownProps.match.params.id;

	const {
		entities: { prices, grades, terms, centers },
		lookups: { paymentTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	return {
		price: prices[priceId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Prices'),
		gradesList: grades,
		terms,
		paymentTypes,
		enableTermPrice: franchisor.enableTermPrice,
		enableTrials: franchisor.enableTrials,
		fixedTermPrice: priceSettingsFormSelector(state, 'fixedTermPrice'),
		selectedCenter: centers[priceSettingsFormSelector(state, 'centerId')],
		selectedTerm: terms[priceSettingsFormSelector(state, 'termId')]
	};
};

export default connect(mapStateToProps, {
	fetchPrice,
	createPrice,
	updatePrice,
	loadUnpagedGrades
})(withTranslation()(Details));